import React from "react";

import styles from "./PracticeField.module.css";

/*
 * The shared `components/form/FormField` reads its error out of react-hook-form's
 * context; this screen stays on Formik, so the same label / control / error shape is
 * rebuilt here rather than changing the form library.
 */
export const PracticeField = ({
  label,
  htmlFor,
  isRequired = false,
  errorMessage,
  children,
  span = "half",
}) => (
  <div className={`${styles.field} ${styles[span]}`}>
    {!!label && (
      <label className={styles.label} htmlFor={htmlFor}>
        <span className={styles.labelText}>{label}</span>
        {!!isRequired && (
          <span className={styles.required} data-required-marker aria-hidden>
            *
          </span>
        )}
      </label>
    )}

    {children}

    {!!errorMessage && <p className={styles.error}>{errorMessage}</p>}
  </div>
);
